module.exports = __webpack_public_path__ + "static/media/1033158.450fa420.jpg";